import { useEffect, useState } from 'react'
import { COMPLEXITY_COMPOUND_METRIC, COMPLEXITY_METRIC, ComplexityDetailItem } from '../../../../../model/caf.interface'
import { useCafMetricsDetailsV5 } from '../../../../../modules/apis/webview/caf'
import useTranslation from '../../../../../modules/i18n/useTranslation'
import { useLessonsStack } from '../../../../../pages/[lang]/webview/lessons'
import LoadingSpinner from '../../../../common/LoadingSpinner'
import { ComplexityDetailSection } from '../../../../new-portal/caf/analysis/complexity/ComplexityDetailSection'
import ViewMoreButton from '../../../../new-portal/caf/common/ViewMoreButton'
import WebviewStackContainer from '../../../common/WebviewStackContainer'

const AIComplexityMetricDetailActivity = ({ params }) => {
  const { useLessonsFlow } = useLessonsStack()
  const { pop } = useLessonsFlow()
  const { metricId, error_tag } = params
  const { t } = useTranslation()
  const {
    data: response,
    error,
    isLoading,
    fetchNextPage,
    isFetchingNextPage,
  } = useCafMetricsDetailsV5<ComplexityDetailItem>(+metricId, +error_tag)
  const [data, setData] = useState<ComplexityDetailItem>(null)

  useEffect(() => {
    if (response?.pages[0]?.words) {
      setData({
        ...response?.pages[0],
        words:
          response?.pages?.reduce((ac: any, cr) => {
            return { ...ac, ...cr.words }
          }, []) || {},
      })
    } else if (response?.pages[0]?.sentences) {
      setData({
        ...response?.pages[0],
        sentences:
          response?.pages?.reduce((ac, cr) => {
            return [...ac, ...cr.sentences]
          }, []) || [],
      })
    } else {
      setData({
        ...response?.pages[0],
      })
    }
  }, [response])

  if (error) return <div className="w-full break-all bg-gray-50 px-[12px]"></div>
  return (
    <div>
      <WebviewStackContainer
        height="52px"
        onBack={pop}
        title={COMPLEXITY_METRIC[data?.level_type] || COMPLEXITY_COMPOUND_METRIC[data?.sentence_type]}
        border={true}
      >
        {isLoading && !data ? (
          <div className="flex min-h-[200px] items-center">
            <LoadingSpinner lg primary show />
          </div>
        ) : (
          <div className="min-h-screen">
            <ComplexityDetailSection data={data} index={COMPLEXITY_METRIC[data?.level_type] ? 0 : 1} />
            <div className="pt-12">
              {response && !!response?.pages[response?.pages.length - 1]?.page?.next && (
                <div className="flex justify-center pb-[88px]">
                  <ViewMoreButton handleClick={fetchNextPage} isFetchingNextPage={isFetchingNextPage} />
                </div>
              )}
            </div>
          </div>
        )}
      </WebviewStackContainer>
    </div>
  )
}

export default AIComplexityMetricDetailActivity
